import React from 'react'
import { apiPost } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import AlertUI from '../../generic/AlertUI'
import { Typography } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueCodeLabel, systemValueLabel } from '../../generic/systemValues/systemValueLabel'

const HistoricSyncRequests = (props) => {
  const [AlertElement, showAlert] = AlertUI()

  const { t_ } = useSmartTranslation()

  const getTableData = async (pagination) => {
    try {
      return await apiPost('historicRequests', pagination)
    } catch (error) {
      showAlert({
        title: t_('Error fetching requests'),
        message: error.message,
        severity: 'error'
      })
      return { content: [], totalElements: 0 }
    }
  }

  const columns = [
    {
      name: t_('Reference'),
      field: 'resourceCode'
    },
    {
      name: t_('Operation'),
      field: 'operationType',
      render: (row) => systemValueCodeLabel(t_, 'ClusterSyncOperationTypeEnum', row.operationType)
    },
    {
      name: t_('Resource'),
      field: 'resourceName',
      // The synchronised resource (cluster_sync_resource), as in PendingSyncRequests.
      render: (row) => systemValueLabel(t_, 'cluster_sync_resource', row.resourceName || '')
    },
    {
      name: t_('Result'),
      field: 'operationResult',
      render: (row) => systemValueCodeLabel(t_, 'ClusterSyncOperationResultEnum', row.operationResult)
    },
    {
      name: t_('Creation date'),
      field: 'createdAt',
      type: 'dateTimePicker'
    },
    {
      name: t_('Node'),
      field: 'clusterNode',
      sortable: false
    },
    {
      name: t_('Description'),
      // ⚠️ Decisión 3 de Iosu (2026-09-11): aquí NO se traduce, a diferencia de Peticiones
      // pendientes. El código estable venía nulo casi siempre —un rechazo decidido por el destino no
      // deja fila de histórico, porque `sync` es transaccional y lanza—, así que se deja de leer y la
      // columna se queda con el texto del servidor, que es lo que ya mostraba en la práctica.
      // Sun retirará el campo de `ClusterSyncHistoryDto` por la misma decisión; esta pantalla no
      // depende de que lo haga ni de cuándo, porque ya no lo mira.
      field: 'operationErrorMessage'
    }
  ]

  return (
    <>
      {AlertElement}

      <SmartMateriaUITable
        title={<Typography color='primary'>{t_('Pending sync requests')} </Typography>}
        columns={columns}
        dataFetch={getTableData}
        multipleSelection={false}
        pageable
        const sortOptions={{
          default: {
            field: 'createdAt',
            direction: -1
          }
        }}
      />
    </>
  )
}

export default HistoricSyncRequests
